import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const sendRoute: RouteConfig<'with-page'> = {
    name: 'Send Documents',
    path: '/send-documents',
    page: lazy(() => import('.')),
    context: 'member',
    flags: ['member-route'],
    permissions: ['companyDocuments', 'sendCompanyDocuments'],
}
